import { useTailgateGrid } from '../../hooks/useTailgateGrid'

import { IncidentOptionI } from '../../types/types'
import { GridTestingZone } from './GridTestingZone'

interface StandaloneGridTestingModalIProps {
  isOpen: boolean
  onClose: () => void
  presetIncident?: IncidentOptionI | null
}

/**
 * Renders the Grid Testing flow without the surrounding TailgateGridModal
 * (used by the Incident Drawer's "View Grid Setup" entry point).
 *
 * The hidden `DummyPlayer` mounts the `<video>` element that `useVideoFrame`
 * captures the camera frame from — without it, the grid/camera view won't
 * load. In the normal (device crud / floor plan) flow, TailgateGridModal
 * renders the DummyPlayer itself; here we render it alongside GridTestingZone.
 */
export const StandaloneGridTestingModal = ({
  isOpen,
  onClose,
  presetIncident,
}: StandaloneGridTestingModalIProps) => {
  const { DummyPlayer, shouldRenderDummyPlayer } = useTailgateGrid()

  return (
    <>
      <GridTestingZone
        isOpen={isOpen}
        onClose={onClose}
        presetIncident={presetIncident}
      />
      {shouldRenderDummyPlayer && <DummyPlayer />}
    </>
  )
}
